

   

<article>
    <h1>DashBoard Update History</h1>


    <div class="dash-board">
        <table>
            <thead>
                <tr>
                    <th>일시</th>
                    <th>항목</th>
                    <th>제목</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor = "let notice of notices | slice: currentPage*10:currentPage*10+10">
                    <td>{{notice.creationDate | date : "yyyy-MM-dd"}}</td>
                    <td>{{notice.part}}</td>
                    <td> {{notice.title}} </td>
                </tr>
            </tbody>
        </table>

        <div class="page-number">
            <button class="btn"><img src="/assets/images/btn-previous-2.png" alt="버튼"></button>
            <button class="btn" (click)="prevPage()" ><img src="/assets/images/btn-previous.png" alt="버튼"></button>
            
            <button class="btn number" *ngFor="let page of pages; let i = index" [ngClass]="{'on': page.selected}" (click)="selectNumber(page,i)">{{i+1}}</button>

            <button class="btn" (click)="nextPage()"><img src="/assets/images/btn-next.png" alt="버튼"></button>
            <button class="btn"><img src="/assets/images/btn-next-2.png" alt="버튼"></button>
        </div>

    </div>
</article>